import { ReactNode, createContext, useContext, useState } from 'react';

import { Spinner } from '@kit/ui/spinner';

type LoadingContextType = {
  setFullscreenLoading: (
    visible: boolean,
    text?: string,
    duration?: number | null,
  ) => void;
};

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export function NrfFullscreenLoadingProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [loadingText, setLoadingText] = useState<string | null>(null);

  const setFullscreenLoading = (
    visible: boolean,
    text: string = 'Laden...',
    duration: number | null = null,
  ) => {
    setIsVisible(visible);
    setLoadingText(text);

    if (visible && duration) {
      setTimeout(() => {
        setIsVisible(false);
        setLoadingText(null);
      }, duration);
    }
  };

  return (
    <LoadingContext.Provider value={{ setFullscreenLoading }}>
      {children}
      {isVisible && (
        <div
          className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/80"
          data-testid="nrf-fullscreen-loading"
        >
          <div className="flex flex-col items-center font-semibold text-white">
            <span className="mb-4">{loadingText}</span>
            <Spinner></Spinner>
          </div>
        </div>
      )}
    </LoadingContext.Provider>
  );
}

export function useFullscreenLoading() {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error(
      'useFullscreenLoading must be used within a FullscreenLoadingProvider',
    );
  }
  return context;
}
